import './ApplicationForm.css';

import { regular } from '@fortawesome/fontawesome-svg-core/import.macro';
import { cloneDeep } from 'lodash';
import React, { useState, useMemo } from 'react'
import { Badge, Form } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux';
import { selectedModeSelector, setApplication } from '../../slices/designerSlice';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Select } from 'antd';
import { useParams } from 'react-router-dom';
import { modesOptions } from '../../utils';
import { ApplicationMode } from '../list-items/BdaApplicationItem';
import { BdaApplication } from '../../models/BdaApplication';
import { RootState } from '../../store';


type Props = {
  onApplicationSubmit: (application: BdaApplication) => void;
}

export default function ApplicationForm({ onApplicationSubmit }: Props) {
  const { id } = useParams();
  const [validated, setValidated] = useState(false);
  const application = useSelector((state: RootState) => state.designer.application);
  const applicationMode = useSelector(selectedModeSelector);
  const dispatch = useDispatch();

  const selectedMode = useMemo(() => modesOptions.find(opt => opt.value === applicationMode), [applicationMode]);

  const handleFieldChange = (field: keyof BdaApplication) => (evt: any) => {
    const value = field === "tags" ? evt : evt.target.value;
    const updatedApp = cloneDeep(application);
    updatedApp[field] = value;
    dispatch(setApplication(updatedApp));
  }

  const handleSubmit = (evt: React.FormEvent<HTMLFormElement>) => {
    const form = evt.currentTarget;
    evt.preventDefault();
    evt.stopPropagation();
    setValidated(true);

    if (form.checkValidity() === true) {
      onApplicationSubmit(application);
    }
  }

  return (
    <>
      <Form className="application-form" noValidate validated={validated} onSubmit={handleSubmit}>
        <div className="form-body">
          <Form.Group className="mb-3" controlId="bda-app-name">
            <Form.Label>Name</Form.Label>
            <Form.Control required size="sm" placeholder="Application Name" value={application.name} onChange={handleFieldChange('name')} />
            <Form.Control.Feedback type="invalid">Application Name is required.</Form.Control.Feedback>
          </Form.Group>

          <Form.Group className="mb-3" controlId="bda-app-description">
            <Form.Label>Description</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              size="sm"
              placeholder="Application Description"
              value={application.description}
              onChange={handleFieldChange('description')} />
          </Form.Group>

          <Form.Group className="mb-3" controlId="bda-app-tags">
            <Form.Label>Tags</Form.Label>
            <Select mode="tags" className="w-100" placeholder="Application Tags" value={application.tags} onChange={handleFieldChange('tags')} />
          </Form.Group>

          <Form.Group className="d-flex align-items-center justify-content-between mb-3">
            <Form.Label>Mode</Form.Label>
            <ApplicationMode mode={selectedMode!.value} />
          </Form.Group>

          <Form.Group className="d-flex align-items-center justify-content-between mb-3">
            <Form.Label>Access Level</Form.Label>
            <Badge>{application.accessLevel}</Badge>
          </Form.Group>
        </div>

        <div className="form-footer">
          <button type="submit">
            <FontAwesomeIcon icon={regular('check-circle')} />
            <span className="ms-2">{id ? 'Edit' : 'Create'} Application</span>
          </button>
        </div>
      </Form>
    </>
  )
}
